import { GET_ALL_TRADERS, GET_SPECEFIC_TRADER } from "./types";

const initialState = {};

const analystReducer = (state = initialState, action) => {
  if (action.type) {
    switch (action.type) {
      case GET_ALL_TRADERS:
        return {
          ...state,
          allTraders: action.payload,
        };
      case GET_SPECEFIC_TRADER:
        return {
          ...state,
          companyTraders: action.payload,
        };

      default: {
        return state;
      }
    }
  }
};

export default analystReducer;
